export default {
    workOrder_contactTab_name: "Name",
    workOrder_contactTab_email: "Email",
    workOrder_contactTab_notifyByEmail: "Notify By Email",
    workOrder_contactTab_phone: "Phone",
    workOrder_contactTab_notifyByPhone: "Notify By Phone",
    workOrder_contactTab_createdOn: "Created At",
}